import { createDateTimeColumn, type TableColumnConfig } from '@pct-ng/feature-table-material';

export function createUpdatedAtColumn<T>(
  i18nPrefix: string,
  sortable = false,
): TableColumnConfig<T> {
  return createDateTimeColumn<T>(
    'updatedAt',
    'updatedAt' as keyof T,
    `${i18nPrefix}UPDATED_AT`,
    sortable,
  );
}
